import React from "react";
import "./Toast.scss";

function Toast({ msg }) {
  return (
    <div className="toast-holder">
      <p>{msg}</p>
      <div className="toast-line"></div>
    </div>
  );
}

export default Toast;
